export default Object.freeze({
  IncludedCredit: 1,
  PromotionalCredit: 2,
  PaidCredit: 3,
  Billable: 4,
  BillableSettlement: 5,
  PurchaseOrderCredit: 6,
});
